<template>
  <div class="contact-page">
    <sub-banner>
      <template v-slot:text>
        <h1>Samen van Waarde</h1>
      </template>
    </sub-banner>
    <section id="over-mij" class="text-image"
             style="flex-direction: row-reverse; padding-top: 100px; margin-top: -50px">
      <div class="container">
        <div class="text-side" data-aos="fade-right" data-aos-duration="1200">
          <p style="font-size: 18px"><em>Voor mantelzorgers</em></p>
          <h1 class="page-title" style="font-weight: 600">Een interactieve bijeenkomst met gedichten, muziek en ontmoeting</h1>
          <span class="stripe"></span>
          <p>
            Arriën Bergkamp en Willemien van Gelder ontmoetten elkaar in het
            woonzorgcentrum waar de vrouw van Arriën woont. Arriën is al jarenlang
            mantelzorger en geeft zijn ervaringen een stem in zelfgeschreven gedichten.
            Willemien maakt muziek met mensen met dementie en ziet dagelijks hoe muziek
            kan verbinden waar woorden soms tekortschieten.
          </p>
        </div>
        <div class="img-side">
          <img alt="Samen van Waarde - Arriën en Willemien in gesprek" src="/images/samen-van-waarde.webp"
               style="border-radius: 40px; max-height: 500px">
        </div>
      </div>
    </section>

    <section class="text-image">
      <div class="container" style="flex-direction: row-reverse">
        <div class="text-side" data-aos="fade-left" data-aos-duration="1200">
          <h1 class="page-title" style="font-weight: 600">Waar woord en klank samenkomen</h1>
          <span class="stripe"></span>
          <p>
            In deze bijeenkomst komen woord en klank samen. Met gedichten en muziek delen
            zij verhalen over liefde, zorg, verlies, veerkracht en verbondenheid. Een
            herkenbare en inspirerende ontmoeting waarin mantelzorgers zich gezien, gehoord
            en erkend mogen voelen.
          </p>
          <br>
          <p>
            Naast deze inbreng is er ruimte voor gesprek en ontmoeting. Een moment om stil
            te staan bij de ervaringen van mantelzorgers. De betrokkenheid en liefde van hen
            blijft van grote waarde voor de invulling van de zorg in de toekomst.
          </p>
          <br>
          <p>
            Een bijeenkomst vol herkenning, ontmoeting en verbinding, waarin ieders ervaring
            ertoe doet.
          </p>
        </div>
        <div class="img-side">
          <img alt="Willemien maakt muziek met Arriën" src="/images/samen-van-waarde-2.webp"
               style="border-radius: 40px; max-height: 500px">
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="container">
        <p>Meer weten of een bijeenkomst aanvragen?</p>
        <router-link to="/contact">Neem contact op</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import TextImage from '@/components/TextImage.vue'
import SubBanner from "@/components/SubBanner";

export default {
  name: "SamenVanWaarde",
  components: {
    SubBanner,
    TextImage
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {
    window.scrollTo(0, 0)
    AOS.init();
  }
}
</script>

<style lang="scss" scoped>

$gold: #C99D66;

.contact-title {
  @media (max-width: 700px) {
    font-size: 25px;
    line-height: 30px;
  }
}

.cta-section {
  margin: 60px 0 100px;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    p {
      font-size: 24px;
      font-weight: 600;
      color: #222222;
      text-align: center;
    }

    a {
      padding: 12px 50px;
      font-weight: 700;
      font-size: 20px;
      color: white;
      background-color: $gold;
      text-decoration: none;
      transition: .25s ease;
      font-family: 'Avenir LT Std', sans-serif;

      &:hover {
        background-color: #8a6c49;
      }
    }
  }
}

</style>
